const updates = [
  { date: '2026-07-29', time: '14:30', text: '每日大赛官方网址已更新，最新入口已同步至本站导航页', highlight: true },
  { date: '2026-07-28', time: '09:15', text: '每日大赛APP iOS版本发布v3.2.1更新，修复已知闪退问题', highlight: false },
  { date: '2026-07-27', time: '16:45', text: '新增一条每日大赛备用镜像站点，提升访问稳定性', highlight: false },
  { date: '2026-07-26', time: '11:20', text: '每日大赛官方发布7月赛事数据报告，参与人数再创新高', highlight: false },
  { date: '2026-07-25', time: '08:00', text: '安卓版每日大赛APP上线全新赛事预约功能，用户体验大幅提升', highlight: false },
  { date: '2026-07-24', time: '20:30', text: '因网络波动导致部分用户访问异常，官方已紧急修复并恢复服务', highlight: false },
  { date: '2026-07-23', time: '15:10', text: '每日大赛官方网站上线新版首页，界面全面焕新升级', highlight: false },
  { date: '2026-07-22', time: '10:00', text: '官方发布《每日大赛用户行为白皮书》，数据洞察深度解读', highlight: false },
  { date: '2026-07-21', time: '17:50', text: '每日大赛官方客服系统升级，响应速度提升至15秒以内', highlight: false },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日大赛官方动态与本站更新通知，实时掌握最新资讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div key={idx} className={`relative mb-6 last:mb-0 ${item.highlight ? 'animate-pulse' : ''}`}>
                <div
                  className={`absolute -left-[25px] top-0.5 w-3 h-3 rounded-full border-2 ${
                    item.highlight
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-100 border-primary-300'
                  }`}
                ></div>
                <div className={`p-4 rounded-lg ${
                  item.highlight
                    ? 'bg-primary-50/70 border border-primary-200/60'
                    : 'hover:bg-background-200/50 transition-colors'
                }`}>
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs font-semibold text-foreground-500">{item.date}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    {item.highlight && (
                      <span className="px-2 py-0.5 text-[10px] font-bold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}